import { useEffect, useState } from 'react';
import { getApps, initializeApp } from 'firebase/app';
import { collection, getDocs, getFirestore, limit, orderBy, query } from 'firebase/firestore';
import {
  aggregateLeaderboardRows,
  buildDisciplineFacts,
  formatEasternTimestamp,
} from './livePortfolioProof';

const HEDGEBENCH_PUBLIC_APP_NAME = 'hedgebench-public-proof';
const HEDGEBENCH_PUBLIC_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCkHCcIa14mLUYAOwvEznUYJl4yyvW5DXg',
  authDomain: 'grouplang-firebase.firebaseapp.com',
  projectId: 'grouplang-firebase',
  storageBucket: 'grouplang-firebase.firebasestorage.app',
  messagingSenderId: '4846109376',
  appId: '1:4846109376:web:0f52fc123e53afb4262325',
};
const RECENT_TRADE_LIMIT = 600;

const initialState = {
  isLoading: true,
  error: null,
  rows: [],
  lastUpdatedLabel: null,
  disciplineFacts: buildDisciplineFacts(null),
};

function getHedgeBenchDb() {
  const existingApp = getApps().find(app => app.name === HEDGEBENCH_PUBLIC_APP_NAME);
  const app =
    existingApp || initializeApp(HEDGEBENCH_PUBLIC_FIREBASE_CONFIG, HEDGEBENCH_PUBLIC_APP_NAME);

  return getFirestore(app);
}

export function useLivePortfolioProof() {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    let isMounted = true;

    async function load() {
      setState(current => ({
        ...current,
        isLoading: true,
        error: null,
      }));

      try {
        const db = getHedgeBenchDb();
        const [tradeSnapshot, brokerSnapshot] = await Promise.all([
          getDocs(
            query(collection(db, 'baselineTrades'), orderBy('closeTime', 'desc'), limit(RECENT_TRADE_LIMIT))
          ),
          getDocs(query(collection(db, 'ibkrPositionSnapshots'), orderBy('timestamp', 'desc'), limit(1))),
        ]);

        const rows = aggregateLeaderboardRows(tradeSnapshot.docs.map(doc => doc.data()));
        const latestSnapshot = brokerSnapshot.docs[0]?.data() || null;
        const lastUpdated = rows.length > 0 ? formatEasternTimestamp(rows[0].updatedAt) : null;

        if (!isMounted) {
          return;
        }

        setState({
          isLoading: false,
          error: null,
          rows,
          lastUpdatedLabel: lastUpdated,
          disciplineFacts: buildDisciplineFacts(latestSnapshot),
        });
      } catch (error) {
        if (!isMounted) {
          return;
        }

        setState({
          isLoading: false,
          error,
          rows: [],
          lastUpdatedLabel: null,
          disciplineFacts: buildDisciplineFacts(null),
        });
      }
    }

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return state;
}
